<template>
  <div>
    <b-tabs :destroy-on-hide="true">

      <b-tab-item label="1 game > N packs">
        <games-with-packs-en-masse></games-with-packs-en-masse>
      </b-tab-item>

      <b-tab-item label="1 pack > N maps">
        <packs-with-games-en-masse></packs-with-games-en-masse>
      </b-tab-item>

      <b-tab-item label="Generate random packs">
        <generate-random-packs></generate-random-packs>
      </b-tab-item>

      <b-tab-item label="Public games matrix">
        <public-games-matrix></public-games-matrix>
      </b-tab-item>

      <b-tab-item disabled label="Other">
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import PublicGamesMatrix from '@/components/single/PublicGamesMatrix'
import GamesWithPacksEnMasse from '@/components/single/GamesWithPacksEnMasse'
import PacksWithGamesEnMasse from '@/components/single/PacksWithGamesEnMasse'
import GenerateRandomPacks from '@/components/single/GenerateRandomPacks'

export default {
  name: 'SpecialFeatures',
  components: {GenerateRandomPacks, PublicGamesMatrix, GamesWithPacksEnMasse, PacksWithGamesEnMasse},
  data() {
    return {}
  },
  created() {
  },
  methods: {},
}
</script>

<style scoped>

</style>
